// test1577
(1577 && 0);
